import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LoadingDatePickerSelect from '../Components/LoadingDatePickerSelect';
import { getLoadingDate, setLoadingDate, togglePicker } from '../Actions/LoadingDatePicker.action';

class LoadingDatePickerContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
    }

    componentDidMount() {
        //alert(JSON.stringify(this.props));
        //this.props.getLoadingDate();

        const { loadingDateObject, getLoadingDate, } = this.props;
        if (getLoadingDate) {
            getLoadingDate();
        }
    }

    render() {
        // Render the DatePicker
        const { loadingDateObject } = this.props;
        
        return (
            <div className="top-link">
                <LoadingDatePickerSelect {...{ ...this.props}} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loadingDateObject: state.loadingDatePicker.loadingDateObject,
        showPicker: state.loadingDatePicker.showPicker,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getLoadingDate: () => dispatch(getLoadingDate()),
        setLoadingDate: (dateStr) => dispatch(setLoadingDate(dateStr)),
        togglePicker: () => dispatch(togglePicker())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadingDatePickerContainer);